<template>
	
	<div class="buy">
		<app-header/>
		
		<div class="container">

      <div class="d-inline">
        <button type="button" v-on:click="generateCVS()" class="btn btn-primary">
          CSV
        </button>
      </div>

			<div class="float-right">
				<button type="button" v-b-modal.modalFilters class="btn btn-primary">
					Filtros
				</button>
			</div>

			
			<div class="">
				
			</div>
			<div class="table table-padded">
				<table>
					<thead>
						<tr>
              <th>{{$t('table.id')}}</th>
							<th>{{$t('table.company')}}</th>
							<th>{{$t('table.value')}}</th>
							<th>{{$t('table.action')}}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(company,index) in companies" :key="index">
							<td>{{company.code}}</td>
              <td>{{company.name}}</td>
              <td>${{money(company.balance)}}</td>
							<td></td>
						
						</tr>
					</tbody>
				</table>

				<app-pagination :data="companies"/>
			</div>

      <b-modal id="modalFilters" ref="modalFilters" centered   class='box-modal' title = "Filtrar Empresa" hide-footer>
        
        <div class="box-modal">
        <form v-on:submit.prevent="read"> 
      
          <div class="form-group">
            <label class='control-label'>Código Empresa </label>
            <input type="text"  class="form-control" v-model='filters.codeCompany'> 
          </div>

      
          <div class="d-inline mr-4">
            <button type="submit" v-on:click="clearFilter()" class="btn btn-primary">Limpiar
            </button>
          </div>
          <div class="d-inline">
            <button type="submit"  class="btn btn-primary">Filtrar</button>
          </div>
        </form>

        </div>    
        
      </b-modal>
			
		</div>
			
		<app-footer/>


	</div>
</template>


<script>
import { mapGetters } from "vuex";
import { FETCH_COMPANIES, FETCH_BANKS } from "@/store/actions.type";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppPagination from "@/components/AppPagination.vue";

export default {
  components: {
    AppHeader,
    AppFooter,
    AppPagination
  },
  data: function() {
    return {
      current: "",
      form: {
        payReference: "",
        dateStart: "",
        dateEnd: "",
        user: "",
        bankId: ""
      },
      filters: {
        codeCompany: ""
      },
      data: {},
      processForm: {
        observation: ""
      }
    };
  },

  methods: {
    read() {
      this.$refs.modalFilters.hide();
      this.$store.dispatch(FETCH_COMPANIES, this.filters);
    },

    clearFilter() {
      (this.filters = {}), this.read();
    },

    generateCVS() {
      const rows = this.companies.map(item => {
        return ["#" + item.code, item.name, "$" + item.balance];
      });

      let csvContent = "";
      rows.forEach(function(rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      var hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(csvContent);
      hiddenElement.target = "_blank";
      hiddenElement.download = "Empresas.csv";
      hiddenElement.click();
    }
  },

  computed: {
    ...mapGetters(["banks", "companies"])
  },

  mounted() {
    this.$store.dispatch(FETCH_BANKS);
    this.read();
  }
};
</script>


<style lang="scss">
.buy {
  input {
  }

  label {
    color: #7b7b7b;
    font-weight: 900;
    font-size: 18px;
  }
  select {
    -webkit-appearance: none;
  }

  .box-modal {
    h5 {
      color: #dab51b !important;
      font-weight: 900;
      font-size: 25px;
    }
  }

  .box-filters {
    padding: 20px;
    width: 359px;
    border-radius: 20px;
    box-shadow: 1px 4px 7px rgba(0, 0, 0, 0.38);
    float: right;

    button {
      width: 100%;
    }
  }
}
</style>
